export default "__VITE_ASSET__D37Lmdg___"